import { useState } from 'preact/hooks';
import { api } from '@services/api';

export function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e: Event) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    const response = await api.post<any>('/api/auth/forgot-password', { email });

    if (response.success) {
      setSuccess(true);
    } else {
      setError(response.error || '요청 처리 중 오류가 발생했습니다.');
    }

    setLoading(false);
  };

  return (
    <div class="flex min-h-screen items-center justify-center bg-gray-100">
      <div class="card w-full max-w-md">
        <div class="mb-6 flex flex-col items-center">
          <img src="/logo.svg" alt="DbitLabs Logo" class="mb-3 h-16 w-16" />
          <h1 class="font-brand text-center text-2xl font-bold">DbitLabs : IssueManager</h1>
        </div>

        <h2 class="mb-6 text-center text-lg font-semibold text-gray-700">비밀번호 찾기</h2>

        {success ? (
          <div class="text-center">
            <div class="mb-4 rounded bg-green-100 p-4 text-green-700">
              <p class="font-medium">이메일을 확인해주세요!</p>
              <p class="mt-2 text-sm">
                입력하신 이메일 주소로 비밀번호 재설정 링크를 발송했습니다.
              </p>
            </div>
            <a
              href="/login"
              class="text-sm text-primary-600 hover:text-primary-700 hover:underline"
            >
              로그인 페이지로 돌아가기
            </a>
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            <p class="mb-4 text-sm text-gray-600">
              가입 시 사용한 이메일 주소를 입력하시면 비밀번호 재설정 링크를 보내드립니다.
            </p>

            <div class="mb-4">
              <label class="mb-2 block text-sm font-medium text-gray-700">이메일</label>
              <input
                type="email"
                class="input"
                value={email}
                onInput={(e) => setEmail((e.target as HTMLInputElement).value)}
                placeholder="example@email.com"
                required
              />
            </div>

            {error && (
              <div class="mb-4 rounded bg-red-100 p-3 text-sm text-red-700">{error}</div>
            )}

            <button type="submit" class="btn btn-primary w-full text-white" disabled={loading}>
              {loading ? '처리중...' : '재설정 링크 받기'}
            </button>

            <div class="mt-4 text-center">
              <a
                href="/login"
                class="text-sm text-gray-600 hover:text-gray-800 hover:underline"
              >
                로그인 페이지로 돌아가기
              </a>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}
